import React from 'react';

const defaultSize = 20;
const defaultClass = 'inline-block shrink-0';

/**
 * Map icon name (used in app) to Flaticon Uicons class (fi-rr-*)
 * Library: @flaticon/flaticon-uicons - Regular Rounded
 */
const FLATICON_MAP = {
  users: 'fi-rr-users',
  building: 'fi-rr-building',
  user: 'fi-rr-user',
  clock: 'fi-rr-clock',
  chart: 'fi-rr-chart-simple',
  document: 'fi-rr-document',
  tag: 'fi-rr-tags',
  search: 'fi-rr-search',
  trendUp: 'fi-rr-chart-line-up',
  bot: 'fi-rr-robot',
  note: 'fi-rr-file',
  eye: 'fi-rr-eye',
  pencil: 'fi-rr-pencil',
  trash: 'fi-rr-trash',
  play: 'fi-rr-play',
  pause: 'fi-rr-pause',
  link: 'fi-rr-link',
  warning: 'fi-rr-triangle-warning',
  folder: 'fi-rr-folder',
  check: 'fi-rr-check',
  cross: 'fi-rr-cross',
  chevronDown: 'fi-rr-angle-down',
  chevronRight: 'fi-rr-angle-right',
  chevronLeft: 'fi-rr-angle-left',
  sortArrow: 'fi-rr-angle-small-down',
  refresh: 'fi-rr-refresh',
  mail: 'fi-rr-envelope',
  globe: 'fi-rr-globe',
  data: 'fi-rr-chart-histogram',
  zap: 'fi-rr-bolt',
  target: 'fi-rr-bullseye',
  menu: 'fi-rr-menu-burger',
  plus: 'fi-rr-plus',
  signOut: 'fi-rr-sign-out',
};

const gradientStyle = {
  background: 'linear-gradient(135deg, #1e3a8a 0%, #0284c7 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

/**
 * Icon Flaticon Uicons - usage: <Icons name="search" size={20} className="text-white" />
 * variant="gradient" for blue-cyan icon color as in menu design.
 * Source: https://www.flaticon.com/uicons
 */
export default function Icons({ name, size = defaultSize, className = '', variant }) {
  const flaticonClass = FLATICON_MAP[name];
  if (!flaticonClass) return null;
  const isGradient = variant === 'gradient';
  return (
    <i
      className={`fi ${flaticonClass} ${defaultClass} ${className}`.trim()}
      style={{
        fontSize: size,
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        ...(isGradient ? gradientStyle : {}),
      }}
      aria-hidden
    />
  );
}

export { FLATICON_MAP };
